import { END_POINT_SEVER } from "../constants";
import axios from "axios";
import {
  SuccessSwal,
  ErrorSwal,
  WarningNetworkFailure,
  WarningError,
} from "../helpers/alertseet";
import { jwtDecode } from "jwt-decode";
import convertMessage from "../helpers/convertMessage";

/**
 * today, yesterday, this_week, last_week, this_month, last_month, this_year, last_year
 */
export const get_balance = async (findby = "?timeFrame=last_year", token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/getBalanceByTime${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    }
    console.error("error", error);
    return { error: true };
  }
};
/**
 * ?startDate=2023-11-09&endDate=2023-11-10
 */
export const get_balances = async (findby = "", token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/getAllBalance${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_activity_history_by_balance_id = async (
  findby = "",
  token
) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/getActivityHistoryByBalanceId${findby}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_balance_by_id = async (_id, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/getBalanceById/${_id}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const add_deposit = async (memberId, data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/balance/addBalance?memberId=${memberId}&branchId=${decoded?.branchId}`;
    const res = await axios.post(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ສ້າງລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const add_withdraw = async (memberId, data, token) => {
  try {
    const decoded = jwtDecode(token);
    const url = `${END_POINT_SEVER}/api/balance/withdraw?memberId=${memberId}&branchId=${decoded?.branchId}`;
    const res = await axios.put(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ສ້າງລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const sumary_dividend_result = async (memberId, data, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/sumaryDividendResult?memberId=${memberId}`;
    const res = await axios.put(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ສ້າງລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    ErrorSwal("ບໍ່ສຳເລັດ");
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const delete_activity_history = async (activityHistoryId, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/activity-history/${activityHistoryId}`;
    const res = await axios.delete(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ລົບລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    ErrorSwal("ບໍ່ສຳເລັດ");
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_activity_history = async (activityHistoryId, token) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/activity-history/${activityHistoryId}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    ErrorSwal("ບໍ່ສຳເລັດ");
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const update_activity_history = async (
  activityHistoryId,
  data,
  token
) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/activity-history/${activityHistoryId}`;
    const res = await axios.put(url, data, {
      headers: { authorization: `Bearer ${token}` },
    });
    SuccessSwal("ແກ້ໄຂລາຍການສຳເລັດ!");
    return res.data;
  } catch (error) {
    ErrorSwal("ບໍ່ສຳເລັດ");
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};

export const get_activity_history_record = async (
  activityHistoryId,
  skip = 0,
  limit = 25,
  token
) => {
  try {
    const url = `${END_POINT_SEVER}/api/balance/activity-history-record/${activityHistoryId}/limit/${limit}/skip/${skip}`;
    const res = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    ErrorSwal("ບໍ່ສຳເລັດ");
    if (error.message === "Network Error") {
      WarningNetworkFailure();
    } else if (error.message) {
      const message = error.response.data.message;
      WarningError(convertMessage(message));
    }
    console.error("error", error);
    return { error: true };
  }
};
